
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import React, { useState } from "react";
import { Stack, Image, Text, DefaultButton, Icon } from "@fluentui/react";

const featureSummaryCss = css`
margin-top: 20px;
  .expandBody {
    max-width: 1000px;
    margin: 10px 0 50px 0;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    padding: 20px;
    background: #faf9f8;
  }
`;

const FeatureSummary = ({
  label = "Feature Summary",
  summary,
  imageUrlPath,
  imageAlt = "Feature Screenshot",
  imageWidth = 800,
  imageHeight = 'auto',
  rootCss = featureSummaryCss,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Stack tokens={{ childrenGap: 10 }} css={rootCss}>
      <DefaultButton
        text={expanded ? `Hide ${label}` : `Show ${label}`}
        iconProps={{ iconName: expanded ? "ChevronUp" : "ChevronDown" }}
        onClick={() => setExpanded((prev) => !prev)}
        style={{ width: "fit-content" }}
      />
      {expanded && (
        <Stack tokens={{ childrenGap: 10 }} className='expandBody'>
          <Text variant="medium">{label}</Text>
          <Text variant="large">{summary}</Text>
          {imageUrlPath && imageUrlPath.trim() !== "" && (
            <Image
              src={`https://images.igrad.com/admin_portal/${imageUrlPath}.png`}
              alt={imageAlt}
              width={imageWidth}
              height={imageHeight}
              styles={{ root: { marginTop: 8 } }}
            />
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default FeatureSummary;
